let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Jr41")).then(() => parcelRequire('kmWFq'));